<template>
    <draggable
        :value="localValue"
        :group="group"
        class="v-treeview v-treeview-draggable"
        ghost-class="ghost"
        @input="updateValue"
        :disabled="disableDrag"
    >
        <draggable-tree-view-node
            v-for="item in value"
            :key="item.id + refresh_count"
            :group="group"
            :value="item"
            :editable="editable"
            :checkable="checkable"
            :initOpened="initOpened"
            :clickCallback="clickCallback"
            :openCallback="openCallback"
            :editCallback="editCallback"
            :deleteCallback="deleteCallback"
            :selectedId="selectedId"
            @input="updateItem"
            @checked="checkedItem"
            :disableDrag="disableDrag"
        >
            <template v-slot:prepend="{ item, open }">
                <slot name="prepend" v-bind="{ item, open }"> </slot>
            </template>
            <template v-slot:label="{ item, open }">
                <slot name="label" v-bind="{ item, open }"> </slot>
            </template>
            <template v-slot:append="{ item, open }">
                <slot name="append" v-bind="{ item, open }"> </slot>
            </template>
        </draggable-tree-view-node>
    </draggable>
</template>

<script>
import Vue from 'vue'
import draggable from 'vuedraggable'
import DraggableTreeViewNode from './DraggableTreeviewNode.vue'

export default Vue.extend({
    components: {
        draggable,
        DraggableTreeViewNode
    },
    props: {
        value: {
            type: Array, // as PropType<{ id: string | number }[]>
            default: () => {
                return []
            }
        },
        group: {
            type: String,
            default: null
        },
        editable: {
            type: Boolean,
            default: false
        },
        checkable: {
            type: Boolean,
            default: false
        },
        initOpened: {
            type: Boolean,
            default: true
        },
        clickCallback: {
            type: Function,
            default: () => {}
        },
        openCallback: {
            type: Function,
            default: () => {}
        },
        editCallback: {
            type: Function,
            default: () => {}
        },
        deleteCallback: {
            type: Function,
            default: () => {}
        },
        selectedId: {
            type: Number
        },
        disableDrag: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            refresh_count: 0,
            localValue: [...this.value]
        }
    },
    watch: {
        value(value) {
            this.localValue = [...value]
        }
    },
    methods: {
        updateValue(value) {
            this.localValue = value
            this.$emit('input', this.localValue)
        },
        updateItem(itemValue) {
            const index = this.localValue.findIndex(v => v.id === itemValue.id)
            this.$set(this.localValue, index, itemValue)
            this.$emit('input', this.localValue)
        },
        checkedItem(value) {
            this.$emit('checked', value)
        }
    }
})
</script>
